import React from 'react';
import '../Styles/Skills.css'
const Skills = () => {
    return (
        <>
            <div data-aos="fade-up-left">
                <section className="skills">
                    <div className="container"  >
                        <div className="text-zone">
                            <h1 className="primary-text"  >
                                <div data-aos="flip-up">
                                    <span className="blast">M</span>
                                    <span className="blast">y</span>
                                    ⠀
                                    <span className="blast">S</span>
                                    <span className="blast">k</span>
                                    <span className="blast">i</span>
                                    <span className="blast">l</span>
                                    <span className="blast">l</span>
                                    <span className="blast">s</span>
                                </div>
                            </h1>

                            <p className="about-text">
                                eius, explicabo quis, dicta amet neque vel porro necessitatibus sit earum quasi optio possimus cumque, illo in nobis voluptas voluptatibus?
                            </p>
                            <p className="about-text second">
                                Minus non fugiat impedit debitis veniam pariatur eveniet Fuga delectus, voluptatibus repudiandae,
                            </p>
                            <p className="about-text">
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Culpa a quisquam delectus aliquam rem id explicabo autem atque ab modi?
                            </p>

                        </div>
                        <div className="skills-zone">
                            <div className="skill ">
                                <h1>Frontned </h1>
                                <div className="line frontend"></div>
                            </div>
                            <div className="skill">
                                <h1>Back end </h1>
                                <div className="line backend"></div>
                            </div>
                            <div className="skill">
                                <h1>Telegram bot</h1>
                                <div className="line design"></div>
                            </div>
                            <div className="skill">
                                <h1>Data Base</h1>
                                <div className="line photoshop"></div>
                            </div>
                        </div>

                    </div>
                </section>
            </div>
        </>
    );
}
export default Skills;